(function() {
    angular.module('tmx-app').controller('applicationStatusReportCtrl', [
        '$mdSidenav',
        'tmxUtility',
        'menu',
        '$mdMedia',
        'ReportService',
        'resolvedData',
        'LoanApplicationService',

        function applicationStatusReportCtrl(
            $mdSidenav,
            tmxUtility,
            menu,
            $mdMedia,
            ReportService,
            resolvedData,
            LoanApplicationService
        ) {
            var applicationStatusReportVM = this;
            applicationStatusReportVM.menu = menu;
            applicationStatusReportVM.gridData = new kendo.data.ObservableArray([]);
            applicationStatusReportVM.search = search;
            applicationStatusReportVM.filterEnabled = false;
            applicationStatusReportVM.toggle = toggle;
            applicationStatusReportVM.isOpen = isOpen;
            var exportLoanApplicationNumber = null;
            var exportBranchId = null;
            var exportNationalId = null;
            var exportFromDate = null;
            var exportToDate = null;

            applicationStatusReportVM.clear = clear;
            applicationStatusReportVM.AllWorkflowStates = [];
            applicationStatusReportVM.AllProducts = [];
            applicationStatusReportVM.formatColumnName = tmxUtility.formatColumnName;
            applicationStatusReportVM.formatDateTime = tmxUtility.formatDateTimeForCompany;
            (function InitializePage() {
                if (tmxUtility.exists(resolvedData)) {
                    applicationStatusReportVM.AllProducts = resolvedData.allActiveProducts.map(x => { return { HiddenValue: x.ProductId, VisibleValue: x.ProductName } });
                }
            })();
            // applicationStatusReportVM.AllWorkflowStates = resolvedData.WorkflowStates.map(x=> { return {LoanProductId : x.ProductId, LoanProductName : x.ProductName}});


            function isOpen(navID) {
                return $mdSidenav(navID).isOpen();
            }

            function clear() {
                applicationStatusReportVM.SelectedWorkflowStates = undefined;

                //  applicationStatusReportVM.container.applicationStatusReportGrid.dataSource.read();
            }


            function toggle() {
                $mdSidenav("ExportSideNav")
                    .toggle()
                    .then(function() {});
            }

            applicationStatusReportVM.exportToPdf = exportToPdf;

            function search() {
                applicationStatusReportVM.container.applicationStatusReportGrid.dataSource.read();
                applicationStatusReportVM.filterEnabled = true;
                exportLoanApplicationNumber = angular.copy(applicationStatusReportVM.LoanApplicationNumber);
                exportBranchId = angular.copy(applicationStatusReportVM.BranchId);
                exportNationalId = angular.copy(applicationStatusReportVM.NationalId);
                exportFromDate = moment(new Date(applicationStatusReportVM.FromDate)).startOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
                exportToDate = moment(new Date(applicationStatusReportVM.ToDate)).endOf('day').toISOString().replace(/:/g, '~').replace("Z", "");
            }

            function exportToPdf() {

                var workflowStates = '';
                if (tmxUtility.exists(applicationStatusReportVM.SelectedWorkflowStates) && applicationStatusReportVM.SelectedWorkflowStates.length > 0) {
                    var selectedHiddenValues = applicationStatusReportVM.SelectedWorkflowStates.map(x => x.HiddenValue);
                    workflowStates = selectedHiddenValues.join(',');
                }
                ReportService.ReportPDF({ StoredProcedure: 'sp_application_status_report', ReportName: 'Application_Status_Report', Orientation: 'Portrait', Arguments: { States: workflowStates } });
            }


            var gridColumns = [{
                    field: tmxUtility.formatColumnName('BranchName'),
                    title: "BranchName",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[ApplicationStatusReportCtrl.formatColumnName('BranchName')]}}</span>",
                    headerTemplate: "<span>Branch Name</span>"
                },
                {
                    field: tmxUtility.formatColumnName('ApplicationNumber'),
                    title: "ApplicationNumber",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[ApplicationStatusReportCtrl.formatColumnName('ApplicationNumber')]}}</span>",
                    headerTemplate: "<span>Application #</span>"
                },
                {
                    field: tmxUtility.formatColumnName('Status'),
                    title: "Status",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[ApplicationStatusReportCtrl.formatColumnName('Status')]}}</span>",
                    headerTemplate: "<span>Status</span>"
                },
                {
                    field: tmxUtility.formatColumnName('Assignee'),
                    title: "Assignee",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[ApplicationStatusReportCtrl.formatColumnName('Assignee')]}}</span>",
                    headerTemplate: "<span>Assign To</span>"
                },
                {
                    field: tmxUtility.formatColumnName('TransitionTime'),
                    title: "TransitionTime",
                    type: "date",
                    template: "<span >{{ApplicationStatusReportCtrl.formatDateTime(dataItem[ApplicationStatusReportCtrl.formatColumnName('TransitionTime')])}}</span>",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    headerTemplate: "<span>Assigned Time</span>"
                },
                {
                    field: tmxUtility.formatColumnName('RequestedAmount'),
                    title: "RequestedAmount",
                    type: "text",
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[ApplicationStatusReportCtrl.formatColumnName('RequestedAmount')]}}</span>",
                    headerTemplate: "<span>Requested Amount</span>"
                }
            ];


            applicationStatusReportVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function(o) {
                            var workflowStates = '';

                            if (tmxUtility.exists(applicationStatusReportVM.SelectedWorkflowStates) && applicationStatusReportVM.SelectedWorkflowStates.length > 0) {
                                var selectedHiddenValues = applicationStatusReportVM.SelectedWorkflowStates.map(x => x.HiddenValue);
                                workflowStates = selectedHiddenValues.join(',');
                            }

                            var objArgs = {
                                "States": workflowStates
                            };

                            var filters = {
                                "StoredProcedure": "sp_application_status_report",
                                "Arguments": objArgs,
                                "ReportName": "Application_Status_Report"
                            };


                            applicationStatusReportVM.o = angular.copy(o);
                            applicationStatusReportVM.filters = applicationStatusReportVM.o.data.filter;

                            firebase.logTmxEvent('report', { name: 'Application Status Report' });
                            ReportService.putByParams(o, true, "ReportDataSourceResultPost", filters).then(function(response) {

                                if (response) {
                                    applicationStatusReportVM.GridResponseData = response.Data;
                                    o.success(response);
                                }
                            });

                            applicationStatusReportVM.filterEnabled = true;

                        },

                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "data.length",
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                pageable: {
                    refresh: true,
                    pageSizes: [5, 10, 15, 20, 100, "All"],
                    pageSize: 20,
                    buttonCount: 4
                },
                excel: {
                    allPages: true,
                    fileName: "ApplicationStatusReport.xlsx"
                },
                excelExport: function(e) {
                    var sheet = e.workbook.sheets[0];
                    var columns = e.workbook.sheets[0].columns;
                    for (var rowIndex = 1; rowIndex < sheet.rows.length; rowIndex++) {

                        //var row = sheet.rows[rowIndex];
                    }
                    columns.forEach(function(column) {
                        delete column.width;
                        column.autoWidth = true;
                    });
                },
                sortable: true,
                scrollable: !$mdMedia("gt-sm"),

                columns: gridColumns
            };

            applicationStatusReportVM.OnProductSelected = function(productId) {
                if (tmxUtility.exists(productId)) {
                    LoanApplicationService.getWorkflowStatesByProductId(productId).then(function(response) {
                        if (tmxUtility.exists(response, 'data')) {
                            applicationStatusReportVM.AllWorkflowStates = response.data.map(x => {
                                if (x.Name != "")
                                    return {
                                        VisibleValue: x.VisibleName,
                                        HiddenValue: x.Name
                                    }
                            });
                        } else {
                            applicationStatusReportVM.AllWorkflowStates = [];
                        }
                    });
                }
            }
        }
    ]);
})();